import React from "react"
import DateCellRenderer from "../../ui/Table/renderers/DateCellRenderer"
import {DateRangeCellRenderer, DriverCellRenderer, StatusCellRenderer, TeamsCellRenderer} from "../Renderers"
import {ReportActionCellRenderer} from "./index"
import {PB_LAST_COLUMN} from "../../ui/Table"

const columns = (formatMessage) => [
  {
    Header: formatMessage({id: "insights.reports.list.column.createdAt"}),
    Cell: (props) => <DateCellRenderer {...props} property="_original.createdAt" />,
    sortable: false,
    minWidth: 120
  },
  {
    Header: formatMessage({id: "insights.reports.list.column.cycle"}),
    accessor: "data.cycle.reference",
    sortable: false,
    style: {whiteSpace: "unset"},
    minWidth: 200
  },
  {
    Header: formatMessage({id: "insights.reports.list.column.driver"}),
    Cell: (props) => <DriverCellRenderer {...props} accessor="_original.data.driver" />,
    sortable: false,
    minWidth: 200
  },
  {
    Header: formatMessage({id: "insights.reports.list.column.teams"}),
    Cell: (props) => <TeamsCellRenderer {...props} accessor="_original.data.team" />,
    sortable: false,
    minWidth: 150
  },
  {
    Header: formatMessage({id: "insights.reports.list.column.time"}),
    Cell: (props) => (
      <DateRangeCellRenderer
        {...props}
        fromAccessor="_original.data.from"
        toAccessor="_original.data.to" />
    ),
    minWidth: 100,
    sortable: false
  },
  {
    Header: formatMessage({id: "insights.reports.list.column.status"}),
    Cell: (props) => <StatusCellRenderer {...props} accessor="_original.status" />,
    minWidth: 150,
    sortable: false
  },
  {
    Header: "",
    Cell: (props) => <ReportActionCellRenderer {...props} />,
    [PB_LAST_COLUMN]: true,
    minWidth: 150,
    sortable: false
  }
]
export default columns
